import Navbar from '../components/navbar/navbar'
import Presentation from '../components/presentation/presentation'
import Services from '../components/services/services'
import About from '../components/about/about'
import Contact from '../components/contact/contact'
import Footer from '../components/footer/footer'

import './home.sass'

const Home = () => {
    return (
        <div className='home'>
            <Navbar/>
            <Presentation/>
            {/* <Services/>
            <About/> */}
            <Contact/>
            <Footer/>
        </div>
    )
}

export default Home